import React, { memo } from 'react';

import { TournamentName } from 'components';
import { ParentPath } from 'types';
import useTournamentHeader from './useTournamentHeader';

import './tournamentHeader.scss';

interface Props {
    sportId: string;
    route: ParentPath;
    sportEventId: string;
    prevSportEventId: string | undefined;
}

const TournamentHeader: React.FC<Props> = ({
    sportId,
    route,
    prevSportEventId,
    sportEventId,
}) => {
    const { hasHeader, tournament } = useTournamentHeader({
        prevSportEventId,
        sportEventId,
    });

    if (!hasHeader || !tournament) return null;

    return (
        <div styleName="header">
            <TournamentName
                sportId={sportId}
                tournamentName={tournament.name}
                masterId={tournament.masterId}
                slug={tournament.slug}
                route={route}
            />
        </div>
    );
};

export default memo(TournamentHeader);
